import type { MetricStep } from "../constants";

interface MetricProgressProps {
  currentStep: MetricStep;
}

const METRICS = [
  { num: 1, label: "Structure" },
  { num: 2, label: "Location" },
  { num: 3, label: "Diagnostic" },
] as const;

export function MetricProgress({ currentStep }: MetricProgressProps) {
  return (
    <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
      <div className="flex items-center gap-1">
        {METRICS.map((metric, i) => {
          const isActive = metric.num === currentStep;
          const isComplete = metric.num < currentStep;
          return (
            <div key={metric.num} className="flex flex-1 items-center">
              <div className="flex flex-1 flex-col items-center">
                <div
                  className={`flex h-7 w-7 items-center justify-center rounded-md text-[11px] font-bold tabular-nums transition-colors ${
                    isComplete
                      ? "bg-emerald-700 text-white"
                      : isActive
                        ? "bg-slate-900 text-white"
                        : "border border-slate-200 bg-white text-slate-400"
                  }`}
                >
                  {isComplete ? "✓" : metric.num}
                </div>
                <span
                  className={`mt-1 text-[9px] font-semibold uppercase tracking-wider ${
                    isActive || isComplete ? "text-slate-700" : "text-slate-400"
                  }`}
                >
                  {metric.label}
                </span>
              </div>
              {i < METRICS.length - 1 && (
                <div
                  className={`mb-4 h-px flex-1 ${metric.num < currentStep ? "bg-emerald-600" : "bg-slate-200"}`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
